/* Utils */
import call from 'utils/Api';

/* Constants */
import type {
  ANALYTICS_EVENT_TYPE,
  ANALYTICS_EVENTS,
} from 'constants/AnalyticsConstants';

const AnalyticsService = async (data: {
  event_type: Values<typeof ANALYTICS_EVENT_TYPE>;
  event: Values<typeof ANALYTICS_EVENTS>;
  visitor_uuid?: string;
  page_version?: string;
  landing_page_email?: string;
  signup_step?: string;
}) => {
  try {
    const resp = await call('analytics/event_log', data);
    return resp.data;
  } catch (e) {
    return null;
  }
};

export default AnalyticsService;
